module.exports = __webpack_public_path__ + "img/institutions.152573f9.svg";